export default __webpack_public_path__ + "static/media/Naif.81271b25.png";